"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserUpdateAdminDto = void 0;
const user_1 = require("../user");
const misc_1 = require("../../../misc");
class UserUpdateAdminDto extends (0, misc_1.generateUpdateDto)(user_1.User, ['name', 'gender', 'doctorProfile']) {
}
exports.UserUpdateAdminDto = UserUpdateAdminDto;
